module.exports = __webpack_public_path__ + "media/images/icons/maestro_small-0d21b170b9f373e537dfa2b54580348d.svg";